import { Logout } from "@mui/icons-material";
import Button, { ButtonProps } from "@mui/material/Button";
import { useOktaAuth } from "@okta/okta-react";
import { useSession } from "../useSession";

export type SignOutButtonProps = ButtonProps;

function SignOutButton(props: ButtonProps) {
  const { oktaAuth } = useOktaAuth();
  const { removeSession } = useSession();
  async function signOutWithOkta() {
    await oktaAuth.signOut();
    removeSession();
  }

  return (
    <Button
      disabled={!oktaAuth}
      variant="outlined"
      size="small"
      disableElevation
      onClick={signOutWithOkta}
      sx={{
        textTransform: "capitalize",
        fontWeight: "normal",
        filter: "opacity(0.9)",
        transition: "filter 0.2s ease-in",
        "&:hover": {
          filter: "opacity(1)",
        },
      }}
      startIcon={<Logout />}
      {...props}
    >
      Déconnexion
    </Button>
  );
}

export { SignOutButton };
